import { render, staticRenderFns } from "./SmsConfirm.vue?vue&type=template&id=db067c1a&scoped=true&"
import script from "./SmsConfirm.vue?vue&type=script&lang=js&"
export * from "./SmsConfirm.vue?vue&type=script&lang=js&"
import style0 from "./SmsConfirm.vue?vue&type=style&index=0&id=db067c1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db067c1a",
  null
  
)

export default component.exports